<!--
 * @name: 修改密码
 * @Description: 修改密码
-->
<template>
  <div class="updatePassword">
    <div class="card">
      <div class="info">
        <font class="title">修改密码</font>
        <div class="line">
          <font class="label">手机号</font>
          <el-input
            class="input"
            v-model="form.mobile"
            maxlength="11"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">验证码</font>
          <el-input
            class="verify_code"
            v-model="form.verify"
            placeholder="请输入验证码"
            clearable
          ></el-input>
          <div
            class="verify_code_btn"
            :class="{ countdown: countdown > 0 }"
            type="primary"
            @click="sendVerify"
          >
            {{ sendVerificationCodeText
            }}{{ countdown === 0 ? "" : "(" + countdown + "s)" }}
          </div>
        </div>
        <div class="line">
          <font class="label">密码</font>
          <el-input
            type="password"
            class="input"
            v-model="form.password"
            placeholder="请输入密码"
            clearable
          ></el-input>
        </div>
        <div class="line">
          <font class="label">确认密码</font>
          <el-input
            type="password"
            class="input"
            v-model="password2"
            placeholder="请再次输入密码"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="btnGroup">
        <el-button type="primary" @click="submit">确认修改</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import sendVerification from "@/mixins/sendVerification";
import userService from "@/module/user/user.service";
import loginTelephoneStorage from "@/storage/loginTelephone.storage";
export default {
  name: "updatePassword",
  mixins: [sendVerification],
  data() {
    return {
      userService: new userService(),
      form: {
        mobile: "",
        verify: "",
        password: "",
      },
      password2: "",
      sendVerificationCodeText: "获取验证码",
    };
  },
  created() {
    this.form.mobile =
      this.$route.query.mobile ||
      new loginTelephoneStorage().getLoginTelephone() ||
      "";
  },
  watch: {
    countdown: {
      handler() {
        this.sendVerificationCodeText = "重新获取";
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @description: 发送验证码
     */
    @debounceation(300)
    sendVerify() {
      this.sendVerificationCode(this.form.mobile, "pwd_verify");
    },
    /**
     * @description: 确认修改密码
     */
    @debounceation(300)
    submit() {
      if(this.form.password.indexOf("123456") > -1) {
        this.$message.error("密码过于简单,请重新填写密码");
        return;
      }
      if (this.form.password !== this.password2) {
        this.$message.error("请确认两次输入的密码相同!");
        return;
      }
      this.userService.updatePassword({ ...this.form }).then(() => {
        this.$message.success("修改密码成功");
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.updatePassword {
  width: 100%;
  height: 100vh;
  @extend .et-flex-center;
  background: $Vars-background-light-gray;
  .card {
    background: $Vars-base-color-white;
    padding: 40px;
    box-shadow: $Vars-boxShadow-normal;
    border-radius: $Vars-border-radius-normal;
    .info {
      width: 500px;
      @extend .et-flex-column-normal;
      .title {
        font-size: $Vars-font-mainTitle-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .line {
        margin-top: 30px;
        @extend .et-flex-start;
        .label {
          font-size: $Vars-font-content-size;
          text-align: left;
          width: 100px;
        }
        .input {
          width: 300px;
          margin-right: 20px;
        }
        .verify_code {
          width: 170px;
          margin-right: 20px;
        }
        .verify_code_btn {
          width: 110px;
          height: 40px;
          border-radius: $Vars-border-radius-normal;
          background: $Vars-normal-color;
          @extend .et-flex-center;
          font-size: 14px;
          color: white;
          @extend .et-clickElement;
          &.countdown {
            opacity: 0.8;
          }
        }
      }
    }
    .btnGroup {
      margin-top: 30px;
      @include grid-column(auto, 200px, 10px);
      justify-content: center;
      .el-button {
        width: 200px;
        margin: 0 !important;
      }
    }
  }
}
</style>
